import React from "react";

const UploadTitle = () => {
  return (
    <div className="custom-drag__title">
      <span className="text-underline">Drag and drop</span> new files or{" "}
      <span className="text-underline">click</span> to select from file
      system...
    </div>
  );
};

export default UploadTitle;
